import React, { useState } from 'react';
import Profits from 'pages/home/ProfitSection/Profits';
import Button from 'components/Button';
import ProfitOne from 'assets/images/bundling-shirt-page1.png';
import DoubleProfitImage from 'assets/images/bundling-shirt-page2.png';
import {
  Container,
  Wrapper,
  Section,
  Content,
  Selector,
} from 'styles/pages/home/profitSection';

const ProfitSection = ({ toggleSignUpDialog }) => {
  const [doubleProfit, setDoubleProfit] = useState(false);
  return (
    <Container id='product-bundling'>
      <Wrapper>
        <Section>
          <Content>
            <img
              src={doubleProfit ? DoubleProfitImage : ProfitOne}
              alt='ProfitOne'
            />
            <Profits
              toggleSignUpDialog={toggleSignUpDialog}
              doubleProfit={doubleProfit}
            />
          </Content>
          <Selector>
            <Button
              containerStyle={{
                borderRadius: '50px',
                background: !doubleProfit ? '#fff' : '',
                color: !doubleProfit ? '#000' : '',
                opacity: !doubleProfit ? 1 : 0.2,
              }}
              variant='text'
              title='Make a profit'
              onClick={() => setDoubleProfit(false)}
            />
            <Button
              variant='text'
              title='Double your profits'
              containerStyle={{
                background: doubleProfit ? '#fff' : '',
                color: doubleProfit ? '#000' : '',
                opacity: doubleProfit ? 1 : 0.2,
              }}
              onClick={() => setDoubleProfit(true)}
            />
          </Selector>
        </Section>
      </Wrapper>
    </Container>
  );
};

export default ProfitSection;
